const AppRoutes = {
  login: '/',
  consent: '/consent-form',
  landing: '/switch-modules',
  home: '/home',
  addCompany: '/companies/new',
  editCompany: '/companies/:companyId/edit',
  companyProfile: '/company/:companyId',
  samlCallback: '/auth/saml/callback',
  samlError: '/auth/saml/error',
  samlDomain: '/saml/domain',
  users: '/users',
  adduser: '/users/add-customer-user',
  editUser: '/edit-user/:id',
  userProfile: '/user/:id',
  notAuthorized: '/autherror',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password/:token',
  firstTimePassword: '/first-time-password',
  usersBatchActionsStatus: '/users/batch-actions-status',
  actionStatusDetails: '/users/status-details/:id',
  NotificationInbox: '/notifications/inbox',
  notificationCenter: '/notifications/center',
  ActionHistory: '/notifications/action-history',
  notification: '/notification',
  accessDenied: '/access-denied',
  importUsersRoles: '/users/import-users-roles',
  importUsersRolesDetail: '/users/import-users-roles-details/:id',
  disabledUser: '/user/disabled/autherror',
  settings: '/settings',
}

export default AppRoutes
